import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

const SELECTORS = {
  sticky: '.js-sticky-filters-sticky',
  bar: '.js-sticky-filters-bar',
  btn: '.js-sticky-filters-btn',
  closeBtn: '.js-sticky-filters-close-btn',
  panel: '.js-sticky-filters-panel',
  filter: '.js-sticky-filters-filter'
}

export default window.customElements.define(
  'sticky-filters-mobile',
  class extends CustomElement {
    constructor() {
      super()

      this.onImmersiveView = this.onImmersiveView.bind(this)

      this.events = {
        [`click ${SELECTORS.btn}`]: 'onClickBtn',
        [`click ${SELECTORS.closeBtn}`]: 'onClickCloseBtn',
        [`submit ${SELECTORS.form}`]: 'onSubmit',
        [`click ${SELECTORS.filter}`]: 'onClickFilter'
      }
    }

    connectedCallback() {
      super.connectedCallback()

      this.$bar = this.querySelector(SELECTORS.bar)
      this.$btn = this.querySelector(SELECTORS.btn)
      this.$closeBtn = this.querySelector(SELECTORS.closeBtn)
      this.$panel = this.querySelector(SELECTORS.panel)
      this.$sticky = this.querySelector(SELECTORS.sticky)

      const observer = new IntersectionObserver(
        ([e]) => {
          this.toggle(e.intersectionRatio == 1)
        },
        { threshold: [1] }
      )

      observer.observe(this.$sticky.parentElement)

      Emitter.on('immersive-view', this.onImmersiveView)
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    stopPropagation(event) {
      event.stopPropagation()
    }

    onImmersiveView(isImmersive) {
      this.toggle(!isImmersive)
    }

    onClickFilter() {
      this.hide()
    }

    onClickBtn(event) {
      event.preventDefault()

      const alreadyOpen = event.target.classList.contains('is-active')

      this.hide()

      if (alreadyOpen) return

      this.classList.add('is-active')
      event.target.classList.add('is-active')
      this.show()
    }

    onClickCloseBtn(event) {
      event.preventDefault()

      this.hide()
    }

    onSubmit() {
      console.log('submit')
    }

    toggle(show) {
      this.classList.toggle('is-out', !show)
    }

    show() {
      this.open = true

      this.$panel.classList.add('is-active')
    }

    hide() {
      if (!this.open) return
      ;[this.$btn, this.$panel, this].forEach((p) =>
        p.classList.remove('is-active')
      )

      this.open = false
    }
  }
)
